import {MultipleParameter} from './multiple-parameter';
import {SingleParameter} from './single-parameter';
import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class MsgContent {
    @jsonArrayMember(MultipleParameter)
    multipleParameters: MultipleParameter[];

    @jsonArrayMember(SingleParameter)
    singleParameters: SingleParameter[];

    getSingleParameter(name: string): SingleParameter {
       return this.singleParameters.find(x => x.name === name);
    }

    getMultipleParameter(name: string): MultipleParameter {
        return this.multipleParameters.find(x => x.name === name);
    }

    public getError(urlRequested: string = '') {
        const statusParameter: SingleParameter = this.getSingleParameter('Status');

        if (statusParameter == null) {
            return 'Error [Status parameter not found] on request [' + urlRequested + ']';
        }

        let x: string;
        x = statusParameter.getValue();
        if (x !== 'OK') {
            // error: get description
            const descriptionParameter: SingleParameter = this.getSingleParameter('Description');
            if (descriptionParameter === null) {
                return 'Error [Description parameter not found] on request [' + urlRequested + ']';
            }

            return 'Error [' + descriptionParameter.getValue() + '] on request [' + urlRequested + ']';
        }

        // all ok
        return '';
    }
}
